<template>
  <div class="register-page">
    <RegisterForm title="申请免费试用" show-brand />
  </div>
</template>

<script setup>
import RegisterForm from '@/components/RegisterForm.vue'
import { useHead } from '@vueuse/head'
useHead({
  title: '申请免费试用 - DiCloudAccess 点云通'
})
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: safe center;
  background-color: var(--dca-bg);
  color: var(--dca-text);
  padding: 24px 16px;
  box-sizing: border-box;
}

.register-page :deep(.register-form) {
  margin: 0;
}
</style>
